export const ROUND_STATUS = {
  PREPARING: 'preparing',
  PLAYING: 'playing',
  ENDED: 'ended',
}
